import React from "react"
import "./About.css"
import { FaFacebookF } from "react-icons/fa"
import { BsLinkedin, BsTwitter, BsInstagram } from "react-icons/bs"
import { GrMail } from "react-icons/gr"
import Aos from "aos"
import Hero from "./Hero"
import "aos/dist/aos.css"

const About = () => {
  React.useEffect(() => {
    Aos.init({ duration: 1200 })
  }, [])

  return (
    <section className="about" data-aos="fade-up">
      <h1 data-aos="fade-up">About Us</h1>
      <Hero />
      <p className="slogan">
        <span id="sloganTxt">
          <span>“Innovation distinguishes between </span>
          <span>a leader and a follower”</span>
        </span>
        <span id="steveJobs">
          <span id="sloganSpace">&nbsp;-&nbsp;</span>Steve Jobs
        </span>
      </p>
      <p>
        The world is getting ready to welcome your innovative ideas everywhere.
        Whether it may be the field of ML, AI, Blockchain, IoT, or Development,
        the only thing is the spark in you and the base for you. Club of
        Sustainability and Innovation (CSI) will provide you with the base for
        building your industry-loving projects that hack real-life problems. So,
        join your hands with us, and let’s Ideate, Innovate, and Learn together!
      </p>
      <div className="links">
        <div className="linksRow">
          <a
            href="https://www.linkedin.com/company/csi-iitbhu/"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin className="icons_about" />
          </a>
          <a
            href="mailto:csi.iitbhu@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <GrMail className="icons_about" />
          </a>
        </div>
        <div className="linksRow">
          <a
            href="https://www.facebook.com/iitbhu.csi/"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF className="icons_about" />
          </a>
          <a
            href="https://www.instagram.com/csi_iitbhu/?hl=en"
            target="_blank"
            rel="noreferrer"
          >
            <BsInstagram className="icons_about" />
          </a>
        </div>
        <div className="linksRow">
          <a
            href="https://twitter.com/csi_iitbhu"
            target="_blank"
            rel="noreferrer"
          >
            <BsTwitter className="icons_about" />
          </a>
        </div>
      </div>
    </section>
  )
}

export default About
